import {
    Grid
} from '@material-ui/core';
import Box from '@mui/material/Box';
import { removeAccents } from '../../../helpers/RemoveAccents';
import { styleFind as style } from '../css/styleSheet';

    const SearcherCardPerformanceEv =({
        initState,
        setState,
        stateInitial,
        setStepFilter,
        stepCampaignFilter,    
        filtroEstado,
        label = "Buscar",   
        width = 420,    
    }:any ) => {
    
    const handleChange = (e: any) => {          
    const array=[...initState]    
    let nuevoFiltrado;
    console.log(e)
    if (e !== '') {           
            nuevoFiltrado =array.filter((lis: any) => removeAccents(lis.namePerformance.toUpperCase()).includes(removeAccents(e.toUpperCase())))          
            const fitrarStatus=nuevoFiltrado.filter((lis: any) => lis.step.toUpperCase().includes(filtroEstado.toUpperCase()))    
            setState(fitrarStatus)         
            setStepFilter(fitrarStatus)    
             return                       
        }
    if (e === '') {      
         const filterArray=[...stateInitial]                
         nuevoFiltrado =filterArray.filter((lis: any) => lis.step.toUpperCase().includes(filtroEstado.toUpperCase()))         
         setState(nuevoFiltrado)        
         setStepFilter(nuevoFiltrado);   
         return
       }               
    };      

    return (
        <Grid item>
            <Box >
                <Grid
                    container
                    direction="row"
                    style={{...style.containerSearcher, width: width}}
                >
                    <Grid item >
                        <input
                            style={{...style.inputSearcher, width: (width - 100)}}
                            className="collaboratorTab__searcher"
                             placeholder={label}
                             onChange={(e) => handleChange(e.target.value)}
                        />
                    </Grid>

                    <Grid item style={{
                        width: "20px",
                        padding: "0 20px 0 40px",
                        color: "#7f7f81",
                        fontStyle: "bold",
                    }}>
                        <img
                            src="/assets/icons/icono-buscar.svg"
                            alt="Buscar"
                        />
                    </Grid>

                </Grid>
            </Box>
        </Grid>

    )
};

export default SearcherCardPerformanceEv
